import React, { useEffect, useState } from 'react';
import Main from '../../Main';
import { Col, Dropdown, Row } from 'react-bootstrap';
import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import '../../../assets/css/dashboard.scss'
import '../../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import Download from '../../MainSection/Download/Download';
import { useDispatch, useSelector } from 'react-redux';
import { loadLotSizeDatas, loadSingleLotSizeDatas, loadZoneMasterDatas } from '../../../redux/action';
import SbDropdownButton from '../../Buttons/SbDropdownButton';
import { SbFilterBtn } from '../../Buttons/Buttons';
import { useLocation } from 'react-router-dom';
import AddAssetBomMaterialBom from './AddAssetBomMaterialBom';
import AssetBomMaterialBomBulkUpload from './AssetBomMaterialBomBulkUpload';
import AssetBomMaterialBomTable from './AssetBomMaterialBomTable';
import ViewAssetBomMaterialBom from './ViewAssetBomMaterialBom';

const AssetBomMaterialBom = () => {
    let dispatch = useDispatch();
    let location = useLocation();

    const { lotSizeData, totalDataCount, singleLotSizeData } = useSelector((state) => state.data);
    console.log(singleLotSizeData, 'singleLotSizeData')
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const storedModulePermissions = JSON.parse(sessionStorage.getItem("modulePermissions")) || [];

    const [moduleData, setModuleData] = useState(null);

    // **Get moduleId from `location.state`**
    const moduleId = location.state?.moduleId;

    useEffect(() => {
        if (moduleId && storedModulePermissions.length) {
            // Find the module data using the moduleId
            const module = storedModulePermissions.find((m) => m.Modules_IDPK === moduleId);
            setModuleData(module);
        }
    }, [storedModulePermissions, moduleId]);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showViewDetails, setShowViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(true);

    const [selectedColumns, setSelectedColumns] = useState([
        "LOT SIZE PROCEDURE", "LS", "LI", "Pds", "LLP", "LLI", "Lper", "DESCRIPTION", "ACTION"
    ]);
    const [lotSizeID, setLotSizeID] = useState("");

    const lotSizeDatas = () => {
        dispatch(loadLotSizeDatas(setLoading, rowsPerPage, page + 1,));
    }
    useEffect(() => {
        lotSizeDatas();
    }, [page, rowsPerPage]);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const handleOpenModal = (lotSizeId) => {
        setIsModalOpen(true);
        if (lotSizeId) {
            dispatch(loadSingleLotSizeDatas(lotSizeId));
            setLotSizeID(lotSizeId);
        } else {
            setLotSizeID("");
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleOpenViewModal = () => {
        setShowViewDetails(!showViewDetails);
    }

    const handleCloseViewModal = () => {
        setShowViewDetails(false)
    }

    const handleOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
    };
    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
    };

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Asset Master & BOM"
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Asset BOM & Material BOM</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                {/* <Col md={3}>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Search Status"
                                        // options={statusOptions}
                                        style={{ width: "100%" }}
                                    />
                                </Col> */}
                                <SbDropdownButton
                                    // pageName="Material Group"
                                    btnName="Add"
                                    openAddModal={() => { handleOpenModal("") }}
                                    addBulkModel={handleOpenBulkUploadModal}
                                />
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <AssetBomMaterialBomTable
                                handleOpenModal={handleOpenModal}
                                handleOpenViewModal={handleOpenViewModal}
                                lotSizeData={lotSizeData}
                                selectedColumns={selectedColumns}
                                loading={loading}
                                page={page}
                                setPage={setPage}
                                rowsPerPage={rowsPerPage}
                                setRowsPerPage={setRowsPerPage}
                                moduleData={moduleData}
                                totalDataCount={totalDataCount}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <AddAssetBomMaterialBom
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    lotSizeID={lotSizeID}
                    singleLotSizeData={singleLotSizeData}
                    lotSizeDatas={lotSizeDatas}
                />
            }
            {
                showBulkUploadModal && <AssetBomMaterialBomBulkUpload
                    showBulkUploadModal={showBulkUploadModal}
                    handleCloseBulkUploadModal={handleCloseBulkUploadModal}
                // deptData={deptData}
                />
            }
            {/* {showColumnFilterModal && (
                <CustomerFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                />
            )}
            {showValueFilterModal && (
                <CustomerValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )} */}
            {showViewDetails && (
                <ViewAssetBomMaterialBom
                    showViewDetails={showViewDetails}
                    handleCloseViewModal={handleCloseViewModal}
                />
            )}
        </div >
    );
};

export default AssetBomMaterialBom;